import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { PrismBadge, PrismIcon } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import { local } from 'embroider-css-modules';
import HotelAndMarketNavigationNavigationLink from 'lumen/components/hotel-and-market/navigation/navigation-link';

import styles from './tab-main-navigation.module.css';

interface HotelAndMarketNavigationTabsTabMainNavigationSignature {
  Args: {
    item: {
      active?: boolean;
      badge?: string;
      className?: string;
      dataTestId?: string;
      externalUrl?: string;
      featureName?: string | string[];
      iconName?: IconName;
      label: string;
      queryParams?: Record<string, unknown>;
      route: string;
    };
  };
}

const HotelAndMarketNavigationTabsTabMainNavigation = <template>
  <li
    class={{concat
      (local styles "container" (if @item.active "active"))
      " "
      @item.className
    }}
    data-test-id={{@item.dataTestId}}
  >
    <HotelAndMarketNavigationNavigationLink
      @externalUrl={{@item.externalUrl}}
      @featureName={{@item.featureName}}
      @queryParams={{@item.queryParams}}
      @routeName={{@item.route}}
    >
      <span class="flex items-center {{if @item.iconName 'gap-100'}}">
        {{@item.label}}

        {{#if @item.iconName}}
          <PrismIcon @name={{@item.iconName}} @size="small" />
        {{/if}}

        {{#if @item.badge}}
          <div class={{styles.badge}}>
            <PrismBadge @type="brand">
              <span class={{styles.badge-text}}>{{@item.badge}}</span>
            </PrismBadge>
          </div>
        {{/if}}
      </span>
    </HotelAndMarketNavigationNavigationLink>
  </li>
</template> satisfies TOC<HotelAndMarketNavigationTabsTabMainNavigationSignature>;

export default HotelAndMarketNavigationTabsTabMainNavigation;
